import AppBrand from './AppBrand.jsx';
import AccountChrome from './AccountChrome.jsx';
import { HelpWidget } from '../../help/index.js';
import LanguageSwitcher from '../../components/LanguageSwitcher.jsx';
import BudgetMeter from './BudgetMeter.jsx';
import NotificationBell from '../../components/NotificationBell/NotificationBell.jsx';

/**
 * The fixed-top navbar the default web layout shells declare:
 *
 *   <nav class="navbar navbar-expand-lg navbar-dark bg-primary text-light fixed-top">
 *     <div class="container-fluid">
 *       <a class="navbar-brand">…</a>
 *       <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarNav">…
 *       <div class="collapse navbar-collapse" id="navbarNav"></div>   ← menuData renders here
 *       <div class="ml-auto d-flex align-items-center">…account…</div>
 *     </div>
 *   </nav>
 *
 * Kept as-is, with three deliberate adaptations:
 *
 *  * Bootstrap 5 spacing names (`ms-auto` for the shells' Bootstrap 4 `ml-auto`),
 *    since this project ships Bootstrap 5.
 *  * The collapse is React-controlled instead of `data-bs-toggle`, so it closes on
 *    navigation and can't desync from Bootstrap's own JS instance.
 *  * Responsive `order-*` utilities keep the brand, account chrome and toggler on
 *    one reachable row below `lg`, with the menu stacking underneath when opened —
 *    the shells' raw DOM order would otherwise push the account chrome onto a
 *    third row.
 *  * A `?` HelpWidget (src/help/) sits just left of AccountChrome — not in the raw
 *    shell, added by maintain-in-app-help-docs so every authenticated page can
 *    open the in-app help drawer from the same spot.
 */
export default function AppNavbar({ onToggleNav, navOpen = false }) {
  return (
    <nav className="navbar navbar-dark bg-primary text-light fixed-top app-navbar">
      <div className="container-fluid">
        {/* Below `lg` this opens the nav drawer; from `lg` up the rail is
            permanent and the toggle is hidden by CSS. */}
        <button
          className="navbar-toggler app-navbar__toggle d-lg-none"
          type="button"
          aria-controls="app-sidebar"
          aria-expanded={navOpen}
          aria-label="Toggle navigation"
          onClick={onToggleNav}
        >
          <span className="navbar-toggler-icon" />
        </button>

        <AppBrand className="navbar-brand" />

        <div className="ms-auto d-flex align-items-center">
          {/* W10: English/العربية is one click, not a buried preference —
              a bilingual newsroom switches language mid-task. */}
          {/* W6: remaining budget is visible on every authenticated screen,
              including inside the generation loop — a creative can only
              self-regulate spend if they can see what is left. */}
          <BudgetMeter className="me-3" />
          {/* Approvals inbox notifications (Episodes Plan 2 Task 12) — any
              authenticated user, no RoleRoute: everyone can be an approver or
              a requester waiting on a decision. */}
          <NotificationBell />
          <LanguageSwitcher />
          <HelpWidget className="ms-3 me-3" />
          <AccountChrome className="d-flex align-items-center" />
        </div>
      </div>
    </nav>
  );
}
